/**
 * SubscriptionPartnerProductsCtrl controller
 */

// controller mixins
SubscriptionPartnerProductsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * SubscriptionPartnerProductsCtrl controller
 *
 * @class SubscriptionPartnerProductsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionPartnerProductsCtrl
 */
/* @ngInject */
export default function SubscriptionPartnerProductsCtrl ($scope, $uibModal, authSvc, Subscription, PartnerProduct, pckg, subscription) {
  var vm = this

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription

  /**
   * Currency of subscription
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @type {models.Currency}
   */
  vm.currency = vm.subscription.currency

  /**
   * Delete Paid Partner Product
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @param {Number} productId
   */
  vm.deletePaidPartnerProduct = function (productId) {
    vm.subscription.$paidPartnerProducts = vm.subscription.$paidPartnerProducts.filter(product => product.id !== productId)
  }

  /**
   * Delete Free Partner Product
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @param {Number} productId
   */
  vm.deleteFreePartnerProduct = function (productId) {
    vm.subscription.$freePartnerProducts = vm.subscription.$freePartnerProducts.filter(p => p.id !== productId)
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @function
   */
  vm.addBasicPartnerProducts = function () {
    const initialProducts = angular.copy(vm.subscription.$freePartnerProducts)
    $uibModal.open({
      templateUrl: 'components/packages/views/addFreePartnerProducts.html',
      controller: 'AddFreePartnerProductsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        networkId: function () {
          return pckg.id
        },
        freeProducts: function () {
          return vm.subscription.$freePartnerProducts || []
        },
        paidProducts: function () {
          return vm.subscription.$paidPartnerProducts || []
        }
      }
    }).result
      .then(
        function close (sets) {
          vm.subscription.$freePartnerProducts = angular.copy(sets)
        },
        function dismiss () {
          angular.copy(initialProducts, vm.subscription.$freePartnerProducts) // restore pricing
        })
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @function
   */
  vm.addExtraPartnerProducts = function () {
    const initialProducts = angular.copy(vm.subscription.$paidPartnerProducts || [])
    $uibModal.open({
      templateUrl: 'components/packages/views/addPaidPartnerProducts.html',
      controller: 'AddPaidPartnerProductsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        networkId: function () {
          return pckg.id
        },
        paidProducts: function () {
          return vm.subscription.$paidPartnerProducts || []
        },
        freeProducts: function () {
          return vm.subscription.$freePartnerProducts || []
        }
      }
    }).result
      .then(
        function close (products) {
          vm.subscription.$paidPartnerProducts = angular.copy(products)
          vm.subscription.$paidPartnerProducts.forEach(p => {
            if (!p.monetization) {
              p.monetization = { subscriptionId: vm.subscription.id, type: 'PAID', amount: 0 }
            } else {
              p.monetization.type = 'PAID'
            }
          })
        },
        function dismiss () {
          angular.copy(initialProducts, vm.subscription.$paidPartnerProducts) // restore pricing
        })
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionPartnerProductsCtrl
   * @function
   * @param {Object} product
   */
  vm.editPartnerProduct = function (product) {
    const initialProduct = angular.copy(product)
    $uibModal.open({
      templateUrl: 'components/packages/views/editPaidPartnerProduct.html',
      controller: 'EditPaidPartnerProductCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        pp: function () {
          return product
        },
        subscription: function () {
          return vm.subscription
        }
      }
    }).result
      .then(
        function close () {
        },
        function dismiss () {
          angular.copy(initialProduct, product)
        })
  }
  vm.setProductId = function (product) {
    window.localStorage.setItem('partnerProductId', product.id)
  }
}
